import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import ErrorPage from '../components/ErrorPage';
import LoginPage from '../pages/auth-pages/Login';
import ChatPage from '../pages/chat';
import Dashboard from '../pages/dashboard';
import FilePage from '../pages/files';
import FileDetails from '../pages/files/FileDetails';
import RootLayout from './RootLayout';

const RequireAuth = () => {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          { index: true, element: <ChatPage /> },
          { path: 'chat', element: <ChatPage /> },
          { path: 'files', element: <FilePage /> },
          { path: 'file-details', element: <FileDetails /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);